import { LoadingOverlayerComponent } from "./LoadingOverlayer/LoadingOverlayerComponent";
import { JSLRender } from "jsl-render";

export abstract class Loading {

    public static showLoading(): void {
        if (Loading.el == null) {
            Loading.el = document.createElement("div");
            new JSLRender(Loading.el).render(new LoadingOverlayerComponent());
        }
        document.body.appendChild(Loading.el);
    }

    public static hideLoading(): void {
        if (Loading.el != null && Loading.el.parentElement != null) {
            Loading.el.parentElement.removeChild(Loading.el);
        }
    }

    private static el: HTMLDivElement;

}
